module.exports = __webpack_public_path__ + "img/file_pdf.f91c136b.svg";